/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * How the fitness profile is calculated, in plain words. It states the policy
 * (tested only, most recent, untested left out, history kept), never the
 * scoring maths, so a change to the maths cannot make it untrue.
 */

export type RadarExplainerSubject = "self" | "athlete" | "athletes";

export interface RadarExplainerCopy {
  title: string;
  intro: string;
  bullets: readonly string[];
  closing: string;
}

export const RADAR_EXPLAINER_COPY: Record<RadarExplainerSubject, RadarExplainerCopy> = {
  self: {
    title: "How your fitness profile is calculated",
    intro: "Your fitness profile is built only from results you have tested.",
    bullets: [
      "For each movement we use your most recent tested result, not your best ever. The shape shows where you are now. This is true for every kind of result, skills included.",
      "Training sets are not used for the score. They stay in your history and still count toward your XP.",
      "A movement you have not tested yet is left out until you test it.",
    ],
    closing: "Your score can change when you test again.",
  },
  athlete: {
    title: "How this athlete's fitness profile is calculated",
    intro: "This profile is built only from results this athlete has tested.",
    bullets: [
      "For each movement we use their most recent tested result, not their best ever. The shape shows where they are now. This is true for every kind of result, skills included.",
      "Training sets are not used for the score. They stay in their history and still count toward their XP.",
      "A movement they have not tested yet is left out until they test it.",
    ],
    closing: "Their score can change when they test again.",
  },
  athletes: {
    title: "How these fitness profiles are calculated",
    intro: "Each profile is built only from results that athlete has tested.",
    bullets: [
      "For each movement we use the athlete's most recent tested result, not their best ever. The shape shows where they are now. This is true for every kind of result, skills included.",
      "Training sets are not used for the score. They stay in the athlete's history and still count toward their XP.",
      "A movement an athlete has not tested yet is left out until they test it.",
    ],
    closing: "A score can change when the athlete tests again.",
  },
};
